import { styled } from '@mui/material/styles'
import Dialog, { dialogClasses } from '@mui/material/Dialog'
const PREFIX = 'WrappedComponent'

export const classes = {
  formControl: `${PREFIX}-formControl`,
  appointmentDatePicker: `${PREFIX}-appointmentDatePicker`,
  hideImage: `${PREFIX}-hideImage`,
  imageContainer: `${PREFIX}-imageContainer`,
  instructionsDialogContainer: `${PREFIX}-instructionsDialogContainer`,
  instructionsDialogContentSection: `${PREFIX}-instructionsDialogContentSection`,
  instructionImage: `${PREFIX}-instructionImage`,
  mobileStepper: `${PREFIX}-mobileStepper`,
  navButton: `${PREFIX}-navButton`,
  navButtonLeft: `${PREFIX}-navButtonLeft`,
  navButtonRight: `${PREFIX}-navButtonRight`,
  commentInput: `${PREFIX}-commentInput`,
  root: `${PREFIX}-root`,
}

export const StyledDialog = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    overflow: 'hidden',
    height: '100%',
  },
})

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    height: '100%',
  },
  [`& .${classes.formControl}`]: {
    margin: theme.spacing(1),
    marginLeft: 0,
    marginRight: 0,
    width: '100%',
  },

  [`& .${classes.appointmentDatePicker}`]: {
    margin: theme.spacing(1),
    display: 'block',
  },

  [`& .${classes.hideImage}`]: {
    display: 'none',
  },

  [`& .${classes.imageContainer}`]: {
    paddingTop: '16px',
    overflow: 'hidden',
  },

  [`& .${classes.instructionImage}`]: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    '& img': {
      height: '100%',
      width: '100%',
      objectFit: 'contain',
      webkitUserDrag: 'none',
      khtmlUserDrag: 'none',
      mozUserDrag: 'none',
      oUserDrag: 'none',
      userDrag: 'none',
    },
  },

  [`& .${classes.instructionsDialogContainer}`]: {
    height: '100%',
    display: 'grid',
    gridTemplateRows: '0.5fr auto 0.5fr',
  },

  [`& .${classes.instructionsDialogContentSection}`]: {
    overflowY: 'auto',
  },

  [`& .${classes.mobileStepper}`]: {
    display: 'flex',
    justifyContent: 'center',
  },

  [`& .${classes.navButton}`]: {
    borderRadius: '0px',
    position: 'absolute',
    top: '48%',
    minWidth: '45px',
    height: '34px',
    padding: '30px 0px 30px 0px',
  },

  [`& .${classes.navButtonLeft}`]: {
    left: '0',
  },

  [`& .${classes.navButtonRight}`]: {
    right: '0',
  },

  [`& .${classes.commentInput}`]: {
    marginTop: '5px',
  },
}))
